import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class ReportsRepository<
    ReportsModel
> extends RepositoryBase<ReportsModel> {
    public constructor() {
        super('reports');
    }
}
